"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.gamepad = exports.keyboard = exports.mouse = void 0;
var mouse_1 = require("./input/mouse");
var keyboard_1 = require("./input/keyboard");
var gamepad_1 = require("./input/gamepad");
function createMouse(canvas) {
    var mouseInput = mouse_1.default.create(canvas);
    return {
        start: function () { return mouseInput.start(); },
        update: function () { return mouseInput.update(); },
        getState: function () { return mouseInput.getState(); }
    };
}
function createKeyboard(canvas) {
    var keyboardInput = keyboard_1.default.create(canvas);
    return {
        start: function () { return keyboardInput.start(); },
        update: function () { return keyboardInput.update(); },
        getState: function () { return keyboardInput.getState(); }
    };
}
function createGamepad() {
    var gamepadInput = gamepad_1.default.create();
    return {
        start: function () { return gamepadInput.start(); },
        update: function () { return gamepadInput.update(); },
        getState: function () { return gamepadInput.getState(); }
    };
}
exports.mouse = {
    create: createMouse
};
exports.keyboard = {
    create: createKeyboard
};
exports.gamepad = {
    create: createGamepad
};
